















































































































































































import XLSX from 'xlsx';
import { areaTotalCosecha, areaTotalTrabajadaCosecha, chacrasCerradas, chacrasProceso, chacrasTotal, humedadMediaPonderada, porcentajeAvanceTotal, rindeMedioPonderado } from '../indicators'
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import ModalCheckboxList from '../../core/components/ModalCheckboxList.vue';
import DownloadFileExtension from '../../core/components/DownloadFileExtension.vue';
import ModalInsuranceHarvest from '../../insurance/components/ModalInsuranceHarvest.vue';
import ModalHarvestExportDepuration from '../../insurance/components/ModalHarvestExportDepuration.vue';
import AnalyticHarvestColumns from '../../insurance/components/AnalyticHarvestColumns.vue';
import ListFilters from '../../insurance/components/ListFilters.vue';
import { MultipleSelect } from '../../core/components';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import {
    sortObjectByPropertyName,
    goToUrl,
    getIdsFromList,
    getCurrentTimestamp,
    getParsedAlerts,
    downloadArrayBuffer,
    isNullOrEmpty,
    downloadFile,
    isNumber,
    PRIVILEGE_KEYS,
    formatDate
} from '../../core/utils/';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { InsuranceServices } from '../api/InsuranceServices';
import Axios, { CancelTokenSource } from 'axios';
import { getRanchStateDescription, getUrlRanchDetail, maxLimitDownloadRanchsPdf, ranchStates } from '../utils';
import { dateTypes } from '../../core/models';
import { harvestDepurationExport, HarvestRanchListFilters, InsuranceFilters, sowingDepurationExport } from '../api/models';
import { sortTypes } from '../../core/models/Table';
import { harvestRanchProperties } from '../api/harvestModels';
import { getValueAndUnit, getValueByType, getValueParsedByType, unitsValuesChoices, unitValues } from '../../../features/core/api';
import { farmingTypesDict, getFarmingKeyByType } from '../helpers';

@Component({
    components: {
        Summary,
        Combobox,
        SimpleTable,
        ModalInsuranceHarvest,
        Button,
        Input,
        DownloadFileExtension,
        ModalCheckboxList,
        MultipleSelect,
        ListFilters,
        AnalyticHarvestColumns,
        ModalHarvestExportDepuration
    }
})
export default class InsuranceAnalyticHarvest extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    visibleModalExportDepuration: boolean = false;
    filtersDateRangeSelected: any = [];
    downloadFormatOptions: Array<object> = [];

    searchParams: HarvestRanchListFilters = {
        page: 1,
        page_size: 10,
    };
    
    filtersParams: HarvestRanchListFilters = {};

    updateAnalyticHarvestColumns(newHeaders){
        let self = this;
        let newHeadersInOrder = newHeaders;

        //need to assign the new headers in order but with the format of the default headers
        if(newHeaders.length > 0){
            newHeadersInOrder = [];
            for (let index = 0; index < this.defaultHeaders.length; index++) {
                //recorro todos los headers por defecto
                const defaultHeader = this.defaultHeaders[index]; //header actual

                //busco el nuevo header en los nuevos
                let headerIndex = newHeaders.findIndex(function(item){
                    return item['key'] == defaultHeader['value'];
                });
                if(headerIndex !== -1){
                    //si lo encuentro lo agrego en el orden que corresponde
                    newHeadersInOrder.push({
                        ...defaultHeader,
                        order: newHeaders[headerIndex]['order']
                    });
                }
            }
        }
        //sort headers by order
        if(newHeadersInOrder.length > 0){
            newHeadersInOrder = newHeadersInOrder.sort(function(a, b){
                return a['order'] - b['order'];
            });
        }
        this.headers = newHeadersInOrder;
    }

     sortHeaders(updatedHeaders) {
        this.headers = updatedHeaders;
        let fleetSummaryModal = this.$refs.analyticColumns as HTMLFormElement;
        let fleetSummaryTable = this.$refs.tableAnalyticHarvest as HTMLFormElement;
        if(fleetSummaryModal && fleetSummaryTable){
            fleetSummaryModal.updateHeadersOrder(updatedHeaders);
        }
    }

    searchAction(params:InsuranceFilters){
        this.selectedRanchsByUser = [];
        let pageSize = this.searchParams.page_size;
        this.searchParams.page = 1;
        this.searchParams = {
            page_size: pageSize,
            ...params
        };
        this.findRanchs();
    }

    formatAlert(alerts: string[]) {
        return getParsedAlerts(alerts)
    }

    updateTableOptions({sortBy, sortDesc, itemsPerPage, page}){
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.page = page;
        if(sortBy.length ==  0){
            delete this.searchParams.sort_by;
            delete this.searchParams.sort_type;
        }else{
            let sortType = sortDesc[0] == true ? sortTypes.desc : sortTypes.asc;
            this.searchParams.sort_by = sortBy;
            this.searchParams.sort_type = sortType;
        }
        this.findRanchs();
        
    }

    updateFiltersDateRange(dateRange){
        this.filtersDateRangeSelected = dateRange;
    }

    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties() {
        this.assignPropertiesData();
    }
    
  

    updatesearchParams(page, itemsPerPage){
        this.searchParams.page = page;
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.query = this.searchRanchList;
        this.findRanchs();
    }




    downloadRanchs(fileName: string, extensionSelected: string, includePublicNotes: boolean, versionPdfSelected: object | null) {
        //  console.log("fileName", fileName);
        //  console.log("extensionSelected", extensionSelected);
        this.pendingDownloadRanchs = true;
        let nameOfFile = fileName;

        switch (extensionSelected) {
            case 'PDF':
                this.downloadRanchsToPDF(nameOfFile, includePublicNotes, versionPdfSelected);
                break;

            case 'GeoJSON':
                this.downloadRanchsToGeojson(nameOfFile);
                break;

            case 'Excel':
                this.downloadRanchsToExcel(nameOfFile);
                break;
        }
    }

    noOptionsFound: string = 'No hay opciones que coincidan con la búsqueda';
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    loadingOptionsCompany: boolean = false;
    itemsList: Array<object> = [];
    selectedRanchsByUser: Array<object> = [];
    pendingGeojsonRanchs: boolean = false;
    pendingPDFRanchs: boolean = false;
    pendingExcelRanchs: boolean = false;
    pendingDownloadRanchs: boolean = false;
    visibleModalDownloadRanchs: boolean = false;
    defaultHeaders: any = [
        {
            text: 'Poliza',
            value: 'policy__number',
            sortable: true
        },
        {
            text: 'Chacra',
            value: 'name',
            sortable: true
        },
        {
            text: 'Estado del cálculo',
            value: 'has_changes',
            align: 'center',
            sortable: false
        },
        {
            text: 'Advertencias',
            value: 'warnings',
            sortable: false
        },
        {
            text: 'Inicio',
            value: 'start_date',
            formatter: (value) => {
                return formatDate(value, true)
            },
            align: 'center',
            sortable: true
        },
        {
            text: 'Fin',
            value: 'end_date',
            formatter: (value) => {
                return formatDate(value, true)
            },
            align: 'center',
            sortable: true
        },
        {
            text: 'Tipo de Cultivo',
            value: 'harvest_type',
            align: 'center',
            sortable: true
        },
        {
            text: 'Empresa',
            value: 'company__name',
            sortable: true,
        },
        {
            text: 'Aseguradora',
            value: 'insurance_company__name',
            sortable: true,
        },
        {
            text: '% Avance',
            value: 'progress',
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.humidity)
            },
            sortable: true
        },
        {
            text: 'Rinde',
            value: 'performance',
            unit: unitValues[unitsValuesChoices.performance],
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.performance)
            },
            sortable: true
        },
        {
            text: 'Humedad',
            value: 'humidity',
            unit: unitValues[unitsValuesChoices.humidity],
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.humidity)
            },
            sortable: true
        },
        {
            text: 'Area',
            value: 'area',
            unit: unitValues[unitsValuesChoices.area],
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.area)
            },
            sortable: true
        },
        {
            text: 'Estado',
            value: 'state',
            sortable: true,
            formatter: this.formatRanchState
        },
        {
            text: 'Zafra',
            value: 'harvest__farming__name',
            sortable: true
        },
        {
            text: 'Zafra aseguradora',
            value: 'harvest__farming__insurance_farming__name',
            sortable: true
        },
        {
            text: 'Ranking',
            value: 'ranking',
            sortable: true,
            formatter: (value) => {
                return getValueByType(value, 2)
            }
        },
        {
            text: 'Fecha Siembra',
            value: 'sowing_start',
            sortable: true,
            formatter: (value) => {
                return formatDate(value, true, true)
            }
        },
        {
            text: 'Condición de cierre',
            value: 'closing_condition',
            sortable: true,
        },
        {
            text: 'Fecha Resiembra',
            value: 'resowing_start',
            formatter: (value) => {
                return formatDate(value, true)
            },
            sortable: true,
        },
        {
            text: 'Alertas',
            value: 'alerts',
            sortable: false
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: false
        }
    ];

    headers: any = this.defaultHeaders;

    pendingItems: boolean = false;

    pageTitle: string = 'Vista analítica de Cosecha';
    summaryData: any = [];
    cropTypeOptions: Array<object> = [];
    optionsCompany: Array<object> = [];
    optionsInsuranceCompany: Array<object> = [];

    searchRanchList: string = '';

    //selector reset values
    companyRV: boolean = false;
    cropTypeRV: boolean = false;
    defaultName: string = 'chacras_cosecha_' +  this.getCurrentTime()
    fileName: string = '';
    propertiesData: object | null = null;
    optionsFromResponse: harvestRanchProperties | null = null 

    insuranceCompanies: Array<object> = [];
    companyFarmingPatchData: object = {};
    farmingTypeToDelete: string = '';
    farmingType: number = farmingTypesDict.harvest
    requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
    savedQueries: string[] = [];
    paginationTotalPages: number = 0;
    paginationTotalRows: number = 0;


    formatRanchState(state){
        return getRanchStateDescription(state, this.$_getInsuranceProperties['ranch_states'])
    }
    
    updateSavedFilters(value){
        this.selectedRanchsByUser = [];
        this.savedQueries = value;
    }

    @Watch('savedQueries', { immediate: true, deep: true })
    watchSavedQueries(value){
        this.searchParams.query = value.join(',');
        this.findRanchs();
    }

    getCurrentTime(){
        return getCurrentTimestamp(dateTypes.globalFilterDateFormat);
    }

    clickBtnDownloadRanchs() {
        this.visibilityModalDownloadRanchs(true);
    }

    updateSelectedRanchs(value) {
        this.selectedRanchsByUser = value;
    }

    visibilityModalDownloadRanchs(value) {
        this.visibleModalDownloadRanchs = value;
    }

    downloadRanchsToPDF(nameOfFile: string, includePublicNotes: boolean, versionPdfSelected: object | null) {
        let filteredRanchs = this.getRanchsToExport();
        let ids = getIdsFromList(filteredRanchs);
        if(versionPdfSelected !== null){
            this.searchParams['version_id'] = versionPdfSelected['version_id'].toString();
        }
        InsuranceServices.getRanchPdf(
            ids, 
            nameOfFile, 
            includePublicNotes, 
            this.searchParams,
        )
            .then((res) => {
                    this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Recibirá el archivo PDF a su e-mail',
                    timeout: 12000
                });
                    this.pendingDownloadRanchs = false;
            })
            .catch((error) => {
                this.pendingDownloadRanchs = false;
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'Falló la generación de PDF'
                });
            });
    }

    clickBtnExportDepuration(){
        this.visibilityModalExportDepuration(true);
    }

    visibilityModalExportDepuration(value) {
        this.visibleModalExportDepuration = value;
    }

    downloadRanchsToGeojson(fileName: string) {
        this.pendingDownloadRanchs = true;
        //download filtered ranchs to a geojson file
        let filteredRanchs = this.getRanchsToExport();
        let ids = getIdsFromList(filteredRanchs);
        InsuranceServices.getRanchListGeojson(ids, this.searchParams)
            .then((res) => {
                 fileName += '.geojson';
                let fileData = JSON.stringify(res['data']);
                downloadFile(fileName, fileData)
                this.pendingDownloadRanchs = false;
            })
            .catch((error) => {
                this.pendingDownloadRanchs = false;
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'Falló la generación de GeoJson'
                });
            });
    }

    downloadRanchsToExcel(fileName: string) {
        this.pendingDownloadRanchs = true;
        let filteredRanchs = this.getRanchsToExport();
        let ids = getIdsFromList(filteredRanchs);

        InsuranceServices.getHarvestRanchsAsExcel(ids, this.searchParams)
            .then((res) => {
                this.pendingDownloadRanchs = false;
                downloadArrayBuffer(fileName, res);
            })
            .catch((error) => {
                this.pendingDownloadRanchs = false;
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'Falló la exportación a Excel'
                });
            });
        
    }

    getRanchsToExport() {
        return this.selectedRanchsByUser;
    }

    get getRanchIdsToExport() {
        return getIdsFromList(this.getRanchsToExport())
    }

    get getSearchParams() {
        return this.searchParams;
    }

    get getAditionalLabel() {
        if(this.selectedRanchsByUser.length > 0){
            return `(${this.selectedRanchsByUser.length} Seleccionadas)`;
        }
        return `<b>(Filtros)</b>`;
    }



    seeRanchDetail(item) {
        let ranchId = item['id'];
        let url = getUrlRanchDetail(ranchId);
        goToUrl(url, true);
    }


    @Watch('isCarrier')
    observableIsCarrier() {
        this.checkIfNeedToHideCalcStatus();
    }

    mounted() {
        this.$nextTick(() => {
            this.assignPropertiesData();
            this.checkIfNeedToHideCalcStatus();
        });
    }

    checkIfNeedToHideCalcStatus(){
        if(this.isCarrier){
            this.headers = this.headers.filter(item => item['value'] !== 'has_changes');
        }
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }


 

    assignPropertiesData() {
        this.cropTypeOptions = this.$_getInsuranceProperties['harvest_type'];
        this.setExportFormats(this.$_getInsuranceProperties['geometry_export_formats']);
        this.propertiesData = this.$_getInsuranceProperties;
    }
    setExportFormats(options){
        this.downloadFormatOptions = options;
    }

    findRanchs(){
        this.getRanchList();
    }


    getRanchList(){
        this.requestTokenInstance.cancel();
        this.requestTokenInstance = Axios.CancelToken.source();
        this.searchingItems(true);
        InsuranceServices.getRanchList(
            this.requestTokenInstance, 
            this.searchParams
        )
        .then(res => {
            this.paginationTotalPages = res.totalPages;
            this.paginationTotalRows = res.count;
            this.optionsFromResponse = res.properties;
            this.setTableItems(res.data);
            this.searchingItems(false);

            if(res.summary){
                this.updateSummary(res.summary);
            }
        })
        .catch(err => {
            if(err && err.message == 'Request canceled'){
                this.searchingItems(true);
                return;
            }
            this.paginationTotalPages = 1;
            this.paginationTotalRows = 0;
            this.setTableItems([]);
             this.searchingItems(false);
            if(err && err.response && err.response.data){
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'Ocurrió un error al obtener las chacras'
                });
            }
        })
    }

    getSortedItems(items: Array<object>, kei?) {
        let sortKei = !kei ? 'value' : kei;
        if (items.length > 0) {
            items = items.sort(sortObjectByPropertyName(sortKei));
        }

        return items;
    }

    updateSummary(summary) {
        let area_total_trabajada = summary.total_worked_area,
            area_total = summary.total_area,
            chacras_total = summary.total_ranches,
            chacras_cerradas = summary.closed_ranches,
            chacras_proceso = summary.in_process_ranches,
            avance_total = summary.total_progress,
            rinde_medio_ponderado = summary.total_performance,
            humedad_media_ponderada = summary.total_humidity;
        

        this.setSummaryData(
            area_total_trabajada,
            area_total,
            chacras_total,
            chacras_cerradas,
            chacras_proceso,
            avance_total,
            rinde_medio_ponderado,
            humedad_media_ponderada
        );
    }

    searchingItems(value) {
        this.pendingItems = value;
    }

    setTableItems(items) {
        if(items.length > 0){
            for (let index = 0; index < items.length; index++) {
                let ranch = items[index];
                ranch['alerts'] = this.formatAlert(ranch['alerts']);
            }
        }
        this.itemsList = items;
    }

    parseNumber(value, key) {
        return getValueParsedByType(value, unitsValuesChoices[key]);
    }

    updateInsuranceSearchValue(value) {
         this.selectedRanchsByUser = [];
        this.searchRanchList = value;
        if(isNullOrEmpty(value)){
            delete this.searchParams.query;
        }else{
            this.searchParams.query = value;
        }
        this.searchParams.page = 1
        this.findRanchs();
    }

    setSummaryData(
        area_total_trabajada: number,
        area_total: number,
        chacras_total: number,
        chacras_cerradas: number,
        chacras_proceso: number,
        avance_total: any,
        rinde_medio_ponderado: number,
        humedad_media_ponderada: number
    ) {
        this.summaryData = [
            {
                text: areaTotalCosecha.text,
                value: getValueAndUnit(area_total, unitsValuesChoices.area),
                info: areaTotalCosecha.tooltip
            },
            {
                text: areaTotalTrabajadaCosecha.text,
                value: getValueAndUnit(area_total_trabajada, unitsValuesChoices.area),
                info: areaTotalTrabajadaCosecha.tooltip
            },
            {
                text: chacrasTotal.text,
                value: chacras_total,
                info: chacrasTotal.tooltip
            },
            {
                text: chacrasCerradas.text,
                value: chacras_cerradas,
                info: chacrasCerradas.tooltip
            },
            {
                text: porcentajeAvanceTotal.text,
                value: getValueAndUnit(avance_total, unitsValuesChoices.humidity),
                info: porcentajeAvanceTotal.tooltip
            },
            {
                text: chacrasProceso.text,
                value: chacras_proceso,
                info: chacrasProceso.tooltip
            },
            {
                text: rindeMedioPonderado.text,
                value: getValueAndUnit(rinde_medio_ponderado, unitsValuesChoices.performance),
                info: rindeMedioPonderado.tooltip
            },
            {
                text: humedadMediaPonderada.text,
                value: getValueAndUnit(humedad_media_ponderada, unitsValuesChoices.humidity),
                info: humedadMediaPonderada.tooltip
            }
        ];
    }

    backToInsurance() {
        this.$router.push(NAME_ROUTES.INSURANCE.path);
    }
}
